"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f95 = void 0;
exports.f95 = {
    "_globalvar": [],
    "_phonvar": [],
    "_version": []
};
